import { urlJoin } from '@digital-spiders/misc-utils';
import type { PageDocumentSlugOnly, PageTypeToPathFunction } from './types/types';

export const DEFAULT_LANG = 'en';
export const ALL_LANGS = [DEFAULT_LANG] as const;

// WARNING When updating these three constants update in cms constants too
// WARNING When updating these three constants update in site create_redirects_file_from_cms too
export const ARTICLE_PREFIX_URL = 'blog';
export const INSIGHT_PREFIX_URL = 'insight';

export const HOOK_POINT_WEBSITE_URL = 'https://hookpoint.com';

export const PAGE_DOCUMENT_TYPES = [
  'bk-page',
  'bk-blogPage',
  'hp-website-article',
  'hp-website-insight',
  'hp-website-page',
] as const;

export const PAGE_TYPE_TO_PATH_FUNCTION = {
  'bk-page': (pageDoc: PageDocumentSlugOnly) => urlJoin(pageDoc.slug.current),
  'bk-blogPage': () => urlJoin(ARTICLE_PREFIX_URL),
  'hp-website-article': (articleDoc: PageDocumentSlugOnly) =>
    urlJoin(ARTICLE_PREFIX_URL, articleDoc.slug.current),
  'hp-website-insight': (articleDoc: PageDocumentSlugOnly) =>
    urlJoin(INSIGHT_PREFIX_URL, articleDoc.slug.current),
  'hp-website-page': (hookPointPageDoc: PageDocumentSlugOnly) =>
    urlJoin(hookPointPageDoc.slug.current),
} as const satisfies PageTypeToPathFunction;

export const VIDEO_TYPES_MAP = {
  tiktok: {
    type: 'tiktok',
    title: 'TikTok',
    formatRegex:
      /^.*https:\/\/(?:m|www|vm)?\.?tiktok\.com\/(?:(?:.*\b(?:(?:usr|v|embed|user|video)\/|\?shareId=|\&item_id=)(\d+))|[^/?#&]+).*$/,
  },
  instagram: {
    type: 'instagram',
    title: 'Instagram',
    formatRegex: /^(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel)\/([^/?#&]+).*$/,
  },
  youtube: {
    type: 'youtube',
    title: 'Youtube',
    formatRegex:
      /^(?:https?:\/\/)?(?:(?:(?:www\.)?youtube\.com\/(?:watch\?v=|embed\/|shorts\/))|(?:youtu\.be\/))([^/?#&]+).*$/,
  },
  wistia: {
    type: 'wistia',
    title: 'Wistia',
    formatRegex: /^https:\/\/(.*\.)?wistia\.com|wistia\.net\/(medias|embed)\/.*/,
  },
  vimeo: {
    type: 'vimeo',
    title: 'Vimeo',
    formatRegex: /^https:\/\/(player\.)?vimeo\.com\/video\/\d+/,
  },
} as const;

// WARNING When updating these two constants update in site variables and cms constants too
export const DARK_THEME_COLOR = '#1a1a1a';
export const LIGHT_THEME_COLOR = '#FFFFFF';

export const SITE_DOMAIN = new URL(import.meta.env.SITE).host;

export const ROOT_DOMAIN = import.meta.env.DEV ? 'localhost:8000' : 'hookpoint.com';

export const FUNCTIONS_BASE_URL = import.meta.env.DEV ? '__development__' : '__production__';
